import 'lazysizes/plugins/rias/ls.rias';
import lazySizes from 'lazysizes';
import { debounceTime, fromEvent } from 'rxjs';

lazySizes.cfg.loadHidden = false;

const sizes = [
  40, 80, 160, 240, 320, 480, 640, 768, 890, 950, 1024, 1280, 1536, 1770, 2048, 2560, 3072,
];

type Target = {
  width: number;
  aspect: number;
  element: HTMLElement;
};

document.addEventListener('lazyriasmodifyoptions', (event: CustomEvent) => {
  if (!(event.target instanceof HTMLElement)) {
    return;
  }

  if (!event.detail.aspectratio) {
    const parent = event.target.parentElement;

    event.detail.aspectratio = parent.clientWidth / parent.clientHeight;
  }

  const targets: Target[] = [
    {
      width: 0,
      aspect: event.detail.aspectratio,
      element: event.target,
    },
  ];

  if (event.detail.isPicture) {
    const parent = event.target.parentElement;
    const sources = parent.querySelectorAll('source');

    sources.forEach((source) => {
      targets.push({
        width: parseInt(source.media.replace(/\D/g, ''), 10),
        aspect: parseFloat(source.dataset.aspectratio) || parent.clientWidth / parent.clientHeight,
        element: source,
      });
    });
  }

  const currentTarget = targets.reverse().find((target) => window.innerWidth >= target.width);
  const width = parseInt(currentTarget.element.dataset.maxWidth, 10);
  const height = parseInt(currentTarget.element.dataset.maxHeight, 10);
  const widths = [];

  sizes.forEach((size) => {
    if (currentTarget.aspect) {
      if (size <= width && size / currentTarget.aspect <= height) {
        widths.push(size);
      }
    } else if (size <= width) {
      widths.push(size);
    }
  });

  event.detail.widths = widths;
});

let currentWidth = window.innerWidth;
const reloadImages = () => {
  if (currentWidth === window.innerWidth) {
    return;
  }

  currentWidth = window.innerWidth;
  const images = document.querySelectorAll(`img.${lazySizes.cfg.loadedClass}`);

  images.forEach((image) => {
    image.classList.remove(lazySizes.cfg.loadedClass);
    image.classList.add(lazySizes.cfg.lazyClass);
  });
};

fromEvent(window, 'resize').pipe(debounceTime(250)).subscribe(reloadImages);
